import React from "react";
import { Link, useLocation } from "react-router-dom";

export function Legal() {
  const location = useLocation();
  const isTerms = location.pathname === "/regulamin";

  return (
    <div className="min-h-screen bg-navy-50">
      <nav className="bg-white border-b border-navy-100 px-6 h-16 flex items-center">
        <Link to="/" className="flex items-center gap-2">
          <div className="w-8 h-8 bg-amber-500 rounded-lg flex items-center justify-center">
            <span className="text-navy-950 font-bold text-sm" style={{ fontFamily: "var(--font-display)" }}>K</span>
          </div>
          <span className="text-lg font-bold tracking-tight" style={{ fontFamily: "var(--font-display)" }}>
            Kverna
          </span>
        </Link>
      </nav>

      <div className="max-w-3xl mx-auto px-6 py-12">
        {isTerms ? <Terms /> : <Privacy />}
      </div>
    </div>
  );
}

function Terms() {
  return (
    <article className="prose prose-navy max-w-none">
      <h1>Regulamin serwisu Kverna</h1>
      <p className="text-sm text-navy-400">Ostatnia aktualizacja: 10 lutego 2026</p>

      <h2>1. Postanowienia ogólne</h2>
      <p>Niniejszy regulamin określa zasady korzystania z serwisu Kverna dostępnego pod adresem kverna.net. Serwis jest przeznaczony dla firm świadczących usługi dezynfekcji, dezynsekcji i deratyzacji (DDD).</p>

      <h2>2. Definicje</h2>
      <ul>
        <li><strong>Serwis</strong> — aplikacja webowa Kverna dostępna pod adresem kverna.net</li>
        <li><strong>Użytkownik</strong> — osoba fizyczna lub prawna korzystająca z Serwisu</li>
        <li><strong>Konto</strong> — indywidualne konto Użytkownika w Serwisie</li>
        <li><strong>Abonament</strong> — odpłatny dostęp do funkcji Serwisu</li>
      </ul>

      <h2>3. Rejestracja i konto</h2>
      <p>Rejestracja w Serwisie jest bezpłatna. Każdy nowy Użytkownik otrzymuje 14-dniowy okres próbny z pełnym dostępem do funkcji wybranego planu. Po zakończeniu okresu próbnego wymagane jest wykupienie abonamentu.</p>

      <h2>4. Plany i cennik</h2>
      <p>Serwis oferuje trzy plany abonamentowe: Starter (149 PLN netto/mies.), Pro (299 PLN netto/mies.) oraz Firma (499 PLN netto/mies.). Ceny mogą ulec zmianie z 30-dniowym wyprzedzeniem.</p>

      <h2>5. Płatności</h2>
      <p>Płatności realizowane są za pośrednictwem operatora Tpay. Abonament jest odnawiany automatycznie co miesiąc. Użytkownik może zrezygnować z abonamentu w dowolnym momencie — dostęp zostanie zachowany do końca opłaconego okresu.</p>

      <h2>6. Odpowiedzialność</h2>
      <p>Serwis jest dostarczany w stanie "jak jest" (as is). Dokładamy wszelkich starań, aby Serwis działał bez zakłóceń, jednak nie gwarantujemy jego ciągłej dostępności. Nie ponosimy odpowiedzialności za szkody wynikające z przerw w działaniu Serwisu.</p>

      <h2>7. Dane osobowe</h2>
      <p>Przetwarzanie danych osobowych odbywa się zgodnie z Polityką Prywatności dostępną pod adresem kverna.net/prywatnosc oraz zgodnie z RODO.</p>

      <h2>8. Postanowienia końcowe</h2>
      <p>W sprawach nieuregulowanych niniejszym regulaminem zastosowanie mają przepisy prawa polskiego. Wszelkie spory będą rozstrzygane przez sąd właściwy dla siedziby Usługodawcy.</p>
    </article>
  );
}

function Privacy() {
  return (
    <article className="prose prose-navy max-w-none">
      <h1>Polityka Prywatności</h1>
      <p className="text-sm text-navy-400">Ostatnia aktualizacja: 10 lutego 2026</p>

      <h2>1. Administrator danych</h2>
      <p>Administratorem danych osobowych jest właściciel serwisu Kverna (kverna.net).</p>

      <h2>2. Jakie dane zbieramy</h2>
      <ul>
        <li><strong>Dane rejestracyjne:</strong> imię, adres email, nazwa firmy</li>
        <li><strong>Dane klientów Użytkownika:</strong> dane wprowadzane przez Użytkownika w ramach CRM (nazwy firm, adresy, numery NIP, dane kontaktowe)</li>
        <li><strong>Dane techniczne:</strong> adres IP, typ przeglądarki, czas dostępu</li>
        <li><strong>Dane płatnicze:</strong> przetwarzane przez operatora Tpay — nie przechowujemy danych kart</li>
      </ul>

      <h2>3. Cel przetwarzania</h2>
      <ul>
        <li>Świadczenie usług Serwisu (art. 6 ust. 1 lit. b RODO)</li>
        <li>Rozliczenia i fakturowanie (art. 6 ust. 1 lit. c RODO)</li>
        <li>Komunikacja z Użytkownikiem (art. 6 ust. 1 lit. f RODO)</li>
      </ul>

      <h2>4. Udostępnianie danych</h2>
      <p>Dane mogą być udostępniane:</p>
      <ul>
        <li>Operatorowi płatności Tpay — w celu realizacji płatności</li>
        <li>Platformom fakturowym (np. Fakturownia) — wyłącznie na żądanie Użytkownika w ramach integracji</li>
        <li>Dostawcy usług email (Resend) — w celu wysyłki powiadomień</li>
      </ul>

      <h2>5. Okres przechowywania</h2>
      <p>Dane przechowywane są przez okres korzystania z Serwisu oraz 30 dni po usunięciu konta. Dane rozliczeniowe przechowywane są przez 5 lat zgodnie z wymogami prawa podatkowego.</p>

      <h2>6. Prawa Użytkownika</h2>
      <p>Każdy Użytkownik ma prawo do: dostępu do swoich danych, ich sprostowania, usunięcia, ograniczenia przetwarzania, przenoszenia danych oraz wniesienia sprzeciwu. Kontakt: kontakt@kverna.net</p>

      <h2>7. Pliki cookies</h2>
      <p>Serwis wykorzystuje pliki cookies wyłącznie w celach technicznych (sesja, token uwierzytelniania) oraz analitycznych. Użytkownik może zarządzać cookies w ustawieniach przeglądarki.</p>

      <h2>8. Bezpieczeństwo</h2>
      <p>Stosujemy odpowiednie środki techniczne i organizacyjne w celu ochrony danych, w tym szyfrowanie transmisji (HTTPS), haszowanie haseł oraz szyfrowanie tokenów API.</p>
    </article>
  );
}
